export const engagementAppIdFeatureFlagsEligibilityUserIdDeviceId =
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id";
